import _ from "lodash";
import moment from "moment";
import { get_language } from "../locale";

export const TableHelper = {
  sorter: (tableParams) => {
    let sorter = null;
    if (tableParams.sorter !== undefined) {
      if (tableParams.sorter.column != undefined) {
        // orden de una sola columna
        sorter = `["${tableParams.sorter.order === "descend" ? "-" : ""}${
          tableParams.sorter.field
        }"]`;
      } else if (_.isArray(tableParams.sorter)) {
        // orden de varias columnas
        let array = "";
        tableParams.sorter.forEach((i) => {
          array += `${array === "" ? "" : ","}"${
            i.order === "descend" ? "-" : ""
          }${i.field}"`;
        });
        sorter = `[${array}]`;
      }
    }
    return sorter;
  },
  sorterArray: (tableParams) => {
    let sorter = null;
    if (tableParams.sorter !== undefined) {
      if (tableParams.sorter.column != undefined) {
        // orden de una sola columna
        sorter = [
          `${tableParams.sorter.order === "descend" ? "-" : ""}${
            tableParams.sorter.field
          }`,
        ];
      } else if (_.isArray(tableParams.sorter)) {
        // orden de varias columnas
        let array = [];
        tableParams.sorter.forEach((i) => {
          array.push(`${i.order === "descend" ? "-" : ""}${i.field}`);
        });
        sorter = array;
      }
    }
    return sorter;
  },
};

// Función común para ordenamiento
export const genericSorter = (prop) => (a, b) => {
  if (a[prop] < b[prop]) return -1;
  if (a[prop] > b[prop]) return 1;
  return 0;
};

// Función común para formateo de fecha
export const formatDate = (date, format = "DD/MM/YYYY") => {
  return moment(date).format(
    get_language === "en" && format === "DD/MM/YYYY" ? "MM/DD/YYYY" : format
  );
};
